import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import FilterStyles from '../SidebarOptions/styles.scss';
import { StartingPriceFilter } from './starting-price-filter';
import { useStartingPriceFilter } from './use-starting-price-filter';

export const StartingPriceFilterSidebarOption = () => {
	const startingPriceFilterProps = useStartingPriceFilter(true);

	return (
		<div className={FilterStyles.filterWrapper}>
			<TextBody size="md" className={FilterStyles.filterLabel} bold>
				Starting price
			</TextBody>
			<div className={FilterStyles.filterSeparator}>
				<StartingPriceFilter {...startingPriceFilterProps} />
			</div>
		</div>
	);
};
